import { render, staticRenderFns } from "./NavBarLink.layout.vue?vue&type=template&id=0c1ac072&scoped=true&"
import script from "./NavBarLink.layout.vue?vue&type=script&lang=ts&"
export * from "./NavBarLink.layout.vue?vue&type=script&lang=ts&"
import style0 from "./NavBarLink.layout.vue?vue&type=style&index=0&id=0c1ac072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ac072",
  null
  
)

export default component.exports